import React, { createContext, useState, useContext, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const { getAuthType } = useAuth();
  const userType = getAuthType();

  const [isDark, setIsDark] = useState(() => {
    // ローカルストレージから値を取得、なければデフォルトでtrue（ダークモード）
    const savedTheme = localStorage.getItem(`isDark_${userType}`);
    return savedTheme ? JSON.parse(savedTheme) : true;
  });

  const [sidebarColor, setSidebarColor] = useState(() => {
    // ユーザータイプごとにサイドバーの色を保存
    const savedColor = localStorage.getItem(`sidebarColor_${userType}`);
    return savedColor || 'blue';
  });

  useEffect(() => {
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
    // ユーザータイプごとにダークモード設定を保存
    localStorage.setItem(`isDark_${userType}`, JSON.stringify(isDark));
  }, [isDark, userType]);

  // サイドバーの色が変更されたときの処理を追加
  useEffect(() => {
    localStorage.setItem(`sidebarColor_${userType}`, sidebarColor);
  }, [sidebarColor, userType]);

  const toggleTheme = () => {
    setIsDark(prev => !prev);
  };

  const value = {
    isDark,
    toggleTheme,
    sidebarColor,
    setSidebarColor
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};

export default ThemeContext; 